/* React */
import React, { useRef, useEffect } from "react";

/* React Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/* d3.js */
import * as d3 from "d3";

/* Utils */
import { createSurvivalPlot } from "src/components/charts/survival-plot/survivalPlotRenderer";

/* Components */
import ChartTooltip from "src/components/shared/chart-tooltip/ChartTooltip";

/* Interfaces */
import { ChartDimensionsProps } from "src/shared/interfaces/charts/BaseChart";
import { SurvivalPlotProps } from "src/shared/interfaces/charts/SurvivalPlot";
import { TableProps } from "src/shared/interfaces/charts/Table";
import { ChartTooltipRef } from "src/shared/interfaces/ChartTooltip";

const SurvivalPlot: React.FC<{
  data: SurvivalPlotProps[];
  table: TableProps[];
  dimensions: ChartDimensionsProps;
}> = ({ data, table, dimensions }) => {
  const svgRef = useRef<SVGSVGElement | null>(null);
  const tooltipRef = useRef<ChartTooltipRef>(null);
  const height: number = 492;

  const survivalAnalysisOptionsState = useSelector(
    (state: RootState) => state.survivalAnalysisOptions
  );

  const { showConfidenceIntervals } =
    survivalAnalysisOptionsState;

  useEffect(() => {
    if (!svgRef.current) return;

    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove();

    createSurvivalPlot(
      svg,
      tooltipRef,
      data,
      table,
      dimensions,
      showConfidenceIntervals
    );
  }, [data, table, dimensions, showConfidenceIntervals]);

  return (
    <>
      <ChartTooltip ref={tooltipRef} />
      <svg
        ref={svgRef}
        height={height}
        width={dimensions.width}
      />
    </>
  );
};

export default SurvivalPlot;
